import "./FooterHead.css";

function FooterHead() {
    return (
        <div className="cta-banner">
            <div className="cta-banner__inner">
                <div className="cta-banner__text">
                    <h3 className="cta-banner__title">Have a question?</h3>
                    <p className="cta-banner__desc">Call us for catering inquiries, reservations, or anything about our menu.</p>
                </div>
                <a
                    href="tel:+14794129916"
                    className="cta-banner__btn"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                    </svg>
                    Call (479) 412-9916
                </a>
            </div>
        </div>
    );
}

export default FooterHead;
